import { useMemo, useState } from 'react';
import { pathgen } from 'object-path-generator';
import { useLocation } from 'react-router';
import { Spinner, Typography, useOverlayContext } from 'seagull';
import { redirect, routes } from "../../../../constants";
import { useIoContext } from "../../../../contexts";
import { useUtmsParams } from "../../../../hooks/useUtmsParams";
import { handleRequest } from "../../../../infra/utils";
import XeroLogo from "../../../../integrations/assets/XeroLogo";
import { useStoreActions } from "../../../../store/store-context";
import styles from "./XeroSignInButton.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const XeroSignInButtonTestIds = pathgen('XeroSignInButtonTestIds');
export default function XeroSignInButton(props) {
  const {
    location,
    mode,
    ensureEmail
  } = props;
  const getUtms = useUtmsParams();
  const {
    api
  } = useStoreActions();
  const {
    pathname,
    search
  } = useLocation();
  const {
    showErrorToast
  } = useOverlayContext();
  const {
    changeLocation
  } = useIoContext();
  const [loading, setLoading] = useState(false);
  const returnTo = useMemo(() => redirect.getReturnToFromSearch(search), [search]);
  const iconSize = 24;
  async function handleClick() {
    setLoading(true);
    const utms = getUtms();
    const redirectUrl = returnTo ? "".concat(location.origin).concat(redirect.getPathAndSearch({
      returnTo
    })) : "".concat(location.origin).concat(routes.home);
    const request = mode === 'signUp' ? api.auth.xeroSignUp({
      redirectUrl,
      utms
    }) : api.auth.xeroSignIn({
      redirectUrl,
      utms,
      ensureEmail: ensureEmail ? {
        email: ensureEmail,
        errorUrl: "".concat(location.origin).concat(pathname).concat(routes.loginError)
      } : undefined
    });
    const {
      success,
      data
    } = await handleRequest(request);
    setLoading(false);
    if (success) {
      changeLocation(data);
    } else {
      showErrorToast('Failed to continue with Xero', XeroSignInButtonTestIds.ErrorToast());
    }
  }
  return /*#__PURE__*/_jsx("div", {
    className: styles.root,
    children: /*#__PURE__*/_jsxs("button", {
      className: styles.button,
      "data-testid": XeroSignInButtonTestIds.Button(),
      disabled: loading,
      onClick: handleClick,
      children: [loading ? /*#__PURE__*/_jsx(Spinner, {
        size: iconSize,
        "data-testid": XeroSignInButtonTestIds.Loading()
      }) : /*#__PURE__*/_jsx(XeroLogo, {
        height: iconSize
      }), /*#__PURE__*/_jsx(Typography, {
        skin: loading ? 'disabled' : 'standard',
        children: "Continue with Xero"
      })]
    })
  });
}